import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import liff from '@line/liff'
import _ from 'lodash'
import userProfile from './store/modules/views/userProfile'

const originalPush = Router.prototype.push
Router.prototype.push = async function push(location: string) {
  return (originalPush.call(this, location) as any).catch((err: any) => window.location.reload())
}
Vue.use(Router)

function loadComponent(component: string) {
  return () => import(`@/components/${component}.vue`)
}

function loadIndividualComponent(page: string, component: string) {
  return () => import(`@/components/${page}/${component}.vue`)
}

function loadPage(page: string, component: string) {
  return () => import(`@/views/${page}/${component}.vue`)
}

function initializeLiff(next, LiffId: string = '1656048933-X5ob4WPL') {
  liff
    .init(
      {
      liffId: LiffId,
      },
      () => initializeApp(next),
      (err) => {
        alert(`Can't init web. ${err.message}`)
        console.log('error initiallizeLiff', err)
        liff.logout()
        initializeLiff(next, LiffId)
      }
    )
}

function initializeApp(next, path: string = (window.location.pathname + window.location.search)) {
  if (liff.isLoggedIn()) {
    const accessToken = liff.getAccessToken()
    liff.getProfile().then(
      function(data) {
        store.dispatch('userprofile/setUserLine', {...data, token: accessToken})
        next()
      }).catch(err => {
        alert(`Can't get profile. ${err.response.error}`)
        console.log('error initializeApp', err)
        liff.logout()
        initializeApp(next, path)
      })
  } else {
    // console.log('initializeApp', path)
    // localStorage.setItem('tmpPath', path)
    liff.login({ redirectUri: window.location.origin + '/redirect' })
  }

}

const vueRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      meta: { appbar: true },
      component: loadComponent('BaseTemplate'),
      beforeEnter: async (to, from, next) => {
        const path = localStorage.getItem('tmpPath')
        if (path) {
          // localStorage.removeItem('tmpPath')
          next(path)
          // next(path)
        } else {
          next('/action/profile')
          // next('/home')
        }
      },
    },
    {
      path: '/redirect',
      meta: { appbar: true },
      component: loadComponent('BaseTemplate'),
      beforeEnter: async (to, from, next) => {
        console.log(to.fullPath, to.path)
        let path = localStorage.getItem('tmpPath')
        try {
          const uri = window.location.search.substring(1)
          const params = new URLSearchParams(uri)
          const urlTo = params.get('to')
          if (urlTo) {
            path = Buffer.from(urlTo, 'base64').toString()
          }
        } catch (e) {
          console.log(window.location.search)
        }
        if (path !== from.path ) {
          // localStorage.removeItem('tmpPath')
          next(path)
          // next(path)
        } else {
          next('/action/profile')
          // next('/home')
        }
      },
    },
    {
      path: '/home',
      meta: { appbar: true },
      component: loadComponent('BaseTemplate'),
    },
    {
      path: '/main/:page',
      meta: { appbar: true },
      component: loadComponent('BaseTemplate'),
      children: [
        {
          path: ':id([0-9a-zA-Z]{32})',
          meta: { appbar: true },
        },
        {
          path: ':id([0-9a-zA-Z]{32})/:tab',
          meta: { appbar: true },
        },
        {
          path: ':type/:id([0-9a-zA-Z]{32})/:tab',
          meta: { appbar: true },
        },
        {
          path: ':component',
          meta: { appbar: true },
        },
        {
          path: ':component/:status',
          meta: { appbar: true },
        },
      ],
    },
    {
      path: '/action/:page',
      meta: { appbar: true },
      component: loadComponent('BaseTemplate'),
      children: [
        {
          path: ':id([0-9a-zA-Z]{32})',
          meta: { appbar: true },
        },
        {
          path: ':id([0-9a-zA-Z]{32})/:tab',
          meta: { appbar: true },
        },
        {
          path: ':type/:id([0-9a-zA-Z]{32})/:tab',
          meta: { appbar: true },
        },
        {
          path: ':component',
          meta: { appbar: true },
        },
        {
          path: ':component/:status',
          meta: { appbar: true },
        },
      ],
    },
    {
      path: '/signup',
      component: () => import('./views/signup/Index.vue'),
      children: [
        {
          path: 'success',
          component: () => import('./views/signup/Success.vue'),
        },
      ],
    },
  ],
})
vueRouter.beforeEach((to, from, next) => {
  if (!(['/redirect', '/signup', '/'].includes(to.path))) {
    localStorage.setItem('tmpPath', to.fullPath)
  }
  // store.dispatch('userprofile/setUserLine', {
  //   displayName: 'st.nann 「サンヤーネィ 🦊」',
  //   pictureUrl: 'https://profile.line-scdn.net/0hogR0rHNYMEhvSRkfZN1PH1MMPiUYZzYAFyt_J0hMPX0Se3cXVnt8J0gcOnFEKXUXAywqKh9BOXFG',
  //   statusMessage: 'きかい。|Chance.(sync) (35mm Camera):(smile)(speech bubble)(thought bubble)',
  //   // userId: '11',
  //   // userId: 'U27e65002c00590446ef9333b47662f6b',
  //   userId: 'U8199ed4289cc8eb9721481216f514391', // admin
  //   token: 'eyJhbGciOiJIUzI1NiJ9.HvgBS4rNJKA0wxumxy-U-9VpWS3QJDpktiuDXokkm86sp9wlVMtS1mh7DiIQqiFumeHweSC4ujHcDjKj73-pyHWHwfQnqLlDnpPJpOU-cj74EfbaKyWDufhsIUWYANhLwFywwt_ALp_8is-4pO3BPx5YRP28HWn0hmxE47cXhNI.t0CnuK2xRmhMv3VHRdyu0mjByUtO-1Z8ixdSXgnwcz0',
  //   // userId: 'Uc78d304bb22101f7a45cbaca3f95f63c', // นักบริบาลพี่แนน
  //   // userId: '02',
  // })
  // next()
  initializeLiff(next)
})

export default vueRouter
